(function() {

    /** @type {String} session id */
    var sessionID = '';
    if (window.location.toString().match(/SESS_ID=(\d+)/)) {
        sessionID = RegExp.$1;
    }
 
    /**
     * @memebrOf __Order
     * @type Order
     */
    var Order = (/** @constructor */ function() {

        /** @type {String} session id */
        var sessionID = '';
        if (window.location.toString().match(/SESS_ID=(\d+)/)) {
            sessionID = RegExp.$1;
        }

        /** @type {Object} параметры */
        var opt = {
            ajaxURL : '/oa/'
        };

        function getJSON(action, params, responseHandler) {
            var data = $.extend({ result : 'json' }, params);
            if (sessionID) {
                data['SESS_ID'] = sessionID;
            }
            $.ajax({
                url : opt.ajaxURL + action + '/',
                cache : false,
                dataType : "json",
                data : data,
                type : 'post',
                timeout : 10000,
                success : function(response) {
                    if ($.isFunction(responseHandler)) {
                        responseHandler(response);
                    }
                },
                error : function() {
                    if ($.isFunction(responseHandler)) {
                        responseHandler();
                    }
                    errorHandler();
                }
            });
        }

        function errorHandler() {
            alert('Произошла ошибка при загрузке. Поробуйте обновить страницу!');
        }

        return {
            /**
             * Инициализация
             * @memberOf Order
             * @param {Object} [options] параметры
             */
            init : function(options) {
                $.extend(opt, options);
                Order.BasketBlock.init({
                    selector : opt.basketBlockSelector
                });

                Order.BasketButtons.init({
                    selector : opt.basketButtonsSelector
                });

                var $checkout = $(opt.basketCheckout);
                if ($checkout.length) {
                    $('[name="inn"]').inputmask("9{1,30}");
                    $('[name="kpp"]').inputmask("9{1,30}");
                    $('[name="phone"]').inputmask("+9 (999) 999-9999");
                    //$('[name="email"]').inputmask("email");
                    Order.Checkout.init(basketIface);
                }

            },

            /**
             * Добавить товар в корзину
             * @param {Number} productId идентификатор
             * @param {Number} count количество
             * @param {Function} [responseHandler] хэндлер
             * @returns
             */
            add : function(productId, count, responseHandler,params) {
                var p = { id : productId,
                          count : count  };
                for(var name in params) {
                    p[ name ] = params[name];
                }

                getJSON('add_to_basket', p, function(data) {
                    if (data.item) {
                        Order.BasketBlock.update(data.count, data.summ);
                        if ($.isFunction(responseHandler)) {
                            responseHandler(data);
                        }
                    } else {
                        errorHandler();
                    }
                });
            },

            /**
             * Обновить количество
             * @param {Number} productId идентификатор
             * @param {Number} count количество
             * @param {Function} [responseHandler] хэндлер
             * @returns
             */
            update : function(productId, count, responseHandler) {
                getJSON('update_item', {
                    id : productId,
                    count : count
                }, function(data) {
                    Order.BasketBlock.update(data.count, data.summ);
                    if ($.isFunction(responseHandler)) {
                        responseHandler(data);
                    }
                });
            },

            /**
             * Отправить заказ
             * @param {Array} params массив параметров
             * @param {Function} [responseHandler]
             * @returns
             */
            submit : function(params, responseHandler) {
                var p = {};
                for (var i = 0; i < params.length; i++) {
                    p[ params[i].name ] = params[i].value;
                }
                getJSON('submit', p, function(data) {
                    if ($.isFunction(responseHandler)) {
                        responseHandler(data);
                    }
                });
            },

            getJSON : function(action, params, handler){
                getJSON(action, params, handler);
            }
        };
    })();
    window.Order = Order;
})();